import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/bf-training-adj", params);
};

const getChart = (params) => {
  return restApi.get("/api/bf-training-adj/chart", {params});
};

const getAllForCSV = params => {
  return restApi.post("/api/bf-training-adj/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bf-training-adj/save", data);
};

const bfTrainingAdjService = {
  getAll,
  getChart,
  getAllForCSV,
  upsert
};

export default bfTrainingAdjService;